import React from 'react';
import { 
  Box, 
  Typography, 
  Paper,
  Chip
} from '@mui/material';
import { Reservation } from '../../types';
import { formatDateTime } from '../../utils/dateUtils';

interface ReservationDetailsCardProps {
  reservation: Reservation;
  elevation?: number;
  padding?: number;
}

/**
 * A reusable component for displaying reservation details
 */
const ReservationDetailsCard: React.FC<ReservationDetailsCardProps> = ({ 
  reservation, 
  elevation = 1,
  padding = 2
}) => {
  // Using the formatDateTime utility from dateUtils

  return (
    <Paper elevation={elevation} sx={{ p: padding }}>
      <Typography variant="h6" gutterBottom>Reservation Information</Typography>
      
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">Reservation ID</Typography>
        <Typography variant="body1">{reservation.id}</Typography>
      </Box>
      
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">Start Time</Typography>
        <Typography variant="body1">{formatDateTime(reservation.startDate)}</Typography>
      </Box>
      
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">End Time</Typography>
        <Typography variant="body1">{formatDateTime(reservation.endDate)}</Typography>
      </Box>
      
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">Notes</Typography>
        <Typography variant="body1">{reservation.notes || 'No notes provided'}</Typography>
      </Box>
      
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">Created At</Typography>
        <Typography variant="body1">{formatDateTime(reservation.createdAt)}</Typography>
      </Box>
      
      {reservation.updatedAt && (
        <Box mb={2}>
          <Typography variant="body2" color="text.secondary">Last Updated</Typography>
          <Typography variant="body1">{formatDateTime(reservation.updatedAt)}</Typography>
        </Box>
      )}
    </Paper>
  );
};

export default ReservationDetailsCard;
